
export function isMobileView(): boolean {
  return window.innerWidth < 768;
}
